import { Card } from "@/src/components/wrappers/Card";
import { Booking } from "../../model";
import { Button } from "../../../../components/ui/button";
import { useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../../../components/ui/dialog";
import { FormField, FormItem, FormLabel, FormControl, FormMessage, Form } from "../../../../components/ui/form";
import { z } from "zod";
import { Textarea } from "../../../../components/ui/textarea";
import { useBookingYachtBrokerNotesMutation } from "../../../../lib/bookingYachtBrokerNotesMutation";

const YachtBrokerNotesSection = ({ booking }: { booking: Booking }) => {
  const [brokerNotesModalOpen, setBrokerNotesModalOpen] = useState(false);
  const yachtBrokerNotes = !!booking.yachtBrokerNotes ? booking.yachtBrokerNotes : booking.offerYacht?.yacht?.notes;

  return (
    <Card className="w-full flex flex-col gap-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">Yacht - Broker notes</h3>
        <Button onClick={() => setBrokerNotesModalOpen(true)} variant="link">
          Edit
        </Button>
      </div>
      <EditYachtBrokerNotesModal
        open={brokerNotesModalOpen}
        onOpenChange={setBrokerNotesModalOpen}
        bookingId={booking.id}
        defaultValues={{
          yachtBrokerNotes,
        }}
      />
      <ul>{!!booking.yachtBrokerNotes ? <p>{booking.yachtBrokerNotes}</p> : <span>No notes here</span>}</ul>
    </Card>
  );
};

const yachtNotesSchema = z.object({
  yachtBrokerNotes: z.string().optional(),
});

type YachtBrokerNotesForm = z.infer<typeof yachtNotesSchema>;
const EditYachtBrokerNotesModal = ({
  open,
  onOpenChange,
  defaultValues,
  bookingId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  defaultValues: {
    yachtBrokerNotes?: string;
  };
  bookingId: string;
}) => {
  const updateBookingYachtNotes = useBookingYachtBrokerNotesMutation(bookingId);

  const form = useForm<YachtBrokerNotesForm>({
    resolver: zodResolver(yachtNotesSchema),
    defaultValues: defaultValues,
  });

  const onSubmit = useCallback(
    form.handleSubmit(
      (data) => {
        updateBookingYachtNotes.mutate({
          yachtBrokerNotes: data.yachtBrokerNotes,
        });
        onOpenChange(false);
      },
      () => {
        console.error("FORM ERROR", form.formState.errors, form.getValues());
      },
    ),
    [form],
  );
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={`sm:max-w-[560px] max-h-[calc(100%-80px)] overflow-y-auto`}>
        <DialogHeader>
          <DialogTitle className="text-3xl flex flex-col">Edit yacht broker notes</DialogTitle>
        </DialogHeader>
        <Form {...form}>
          <div className="grid">
            <FormField
              name="yachtBrokerNotes"
              render={({ field }) => (
                <FormItem>
                  <FormLabel className="text-slate-600">Yacht broker notes</FormLabel>
                  <FormControl>
                    <Textarea className="w-full" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </Form>
        <DialogFooter>
          <Button onClick={onSubmit} type="submit">
            Save
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default YachtBrokerNotesSection;
